<div *ngIf="historyPaginated && historyPaginated.length">
  <strong class="bz-space--stack-s">{{'SYNC_DATA.TITLE_HISTORY_EXPORT' | translate}}</strong>
  <div>
    <table class="bz-table">
      <thead>
        <tr>
          <th class="bz-table__cell bmc-sync-data__td-left">
            {{'SYNC_DATA.USERNAME' | translate}}
          </th>
          <th class="bz-table__cell bmc-sync-data__td-left">
            {{'SYNC_DATA.STATUS' | translate}}
          </th>
          <th class="bz-table__cell bmc-sync-data__td-left">
            {{'SYNC_DATA.EXPORTED_DATE' | translate}}
          </th>
          <th class="bz-table__cell bmc-sync-data__td-left">
            {{'SYNC_DATA.EXPORTED_ENTITIES' | translate}}
          </th>
          <th class="bz-table__cell bmc-sync-data__td-center">
            {{'SYNC_DATA.DOWNLOAD' | translate}}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let his of historyPaginated">

          <td class="bz-table__cell">
            {{his.userName}}
          </td>
          <td class="bz-table__cell" [ngSwitch]="his.status">
            <div *ngSwitchCase="'Created'">
              <bzg-icon [nameIcon]="'icon-info-strong'" [color]="'info'"></bzg-icon>
            </div>
            <div *ngSwitchCase="'InProgress'">
              <bzg-icon [nameIcon]="'icon-info-strong'" [color]="'info'"></bzg-icon>
            </div>
            <div *ngSwitchCase="'Error'">
              <bzg-icon [nameIcon]="'icon-error'" [color]="'error'" [bzgTooltip]="his.errorMessage"
                bzgTooltipPosition="above"></bzg-icon>
            </div>
            <div *ngSwitchCase="'Done'">
              <bzg-icon [nameIcon]="'icon-check-mark'" [color]="'success'"></bzg-icon>
            </div>
          </td>
          <td class="bz-table__cell">
            {{his.timestamp | showDateFormat: 1}}
          </td>
          <td class="bz-table__cell">
            {{his.uploadDescription}}
          </td>
          <td class="bz-table__cell bmc-sync-data__td-center">
            <bzg-loading [size]="'s'" [bounce]="true" *ngIf="his.status === 'Created' || his.status === 'InProgress'">
            </bzg-loading>
            <a (click)="onDownloadFile(his.partitionKey, his.rowKey, his.fileName)" *ngIf="his.status === 'Done'">
              <bzg-icon [nameIcon]="'icon-download'" [color]="'active'">
              </bzg-icon>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
    <a #fileLink id="fileLink" style="visibility:hidden"></a>
  </div>
  <div class="bz-table-pagination">
    <bzg-paginator [pageSize]="pageSize" [totalItems]="_history ? _history.length : 5"
      (paginationChanged)="onPaginationEvent($event)" [pageSizeOptions]="[5]">
    </bzg-paginator>
  </div>
</div>
